export class DocxTemplate {
  constructor({ id = NaN, name = "", file = "", usage = {} } = {}) {
    this.id = id;
    this.name = name;
    this.file = file;
    this.usage = usage ? new DocxTemplateUsage(usage) : null;
  }

  get isUsed() {
    return !!this.usage?.workflow?.length;
  }

  get usageCount() {
    if (!this.usage) return 0;
    return this.usage.workflow.length;
  }
}

export class DocxTemplateUsage {
  constructor({ workflow = [] } = {}) {
    this.workflow = workflow?.length
      ? workflow.map((w) => ({ id: w.id, name: w.name }))
      : [];
  }
}
